export default {"src":"/_next/static/media/luvi-new-logo.d12c300f.svg","height":45,"width":82,"blurWidth":0,"blurHeight":0};